var _AsyncEnumerator_baseArray, _AsyncEnumerator_pointer, _AsyncEnumerator_current;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import OutOfBoundsException from '../Exceptions/OutOfBoundsException';
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
export default class AsyncEnumerator {
    constructor(array) {
        // the internal array
        _AsyncEnumerator_baseArray.set(this, void 0);
        // current pointer location
        _AsyncEnumerator_pointer.set(this, -1);
        _AsyncEnumerator_current.set(this, void 0);
        __classPrivateFieldSet(this, _AsyncEnumerator_baseArray, array, "f");
    }
    // returns the current element
    get current() {
        if (!isUndefinedOrNull(__classPrivateFieldGet(this, _AsyncEnumerator_current, "f")) && __classPrivateFieldGet(this, _AsyncEnumerator_pointer, "f") < __classPrivateFieldGet(this, _AsyncEnumerator_baseArray, "f").length && __classPrivateFieldGet(this, _AsyncEnumerator_pointer, "f") >= 0) {
            return __classPrivateFieldGet(this, _AsyncEnumerator_current, "f");
        }
        throw new OutOfBoundsException("internal pointer", 0, __classPrivateFieldGet(this, _AsyncEnumerator_baseArray, "f").length - 1);
    }
    async moveNextAsync() {
        var _a;
        if (__classPrivateFieldGet(this, _AsyncEnumerator_pointer, "f") < __classPrivateFieldGet(this, _AsyncEnumerator_baseArray, "f").length) {
            __classPrivateFieldSet(this, _AsyncEnumerator_pointer, (_a = __classPrivateFieldGet(this, _AsyncEnumerator_pointer, "f"), _a++, _a), "f");
        }
        if (__classPrivateFieldGet(this, _AsyncEnumerator_pointer, "f") < __classPrivateFieldGet(this, _AsyncEnumerator_baseArray, "f").length) {
            __classPrivateFieldSet(this, _AsyncEnumerator_current, await __classPrivateFieldGet(this, _AsyncEnumerator_baseArray, "f")[__classPrivateFieldGet(this, _AsyncEnumerator_pointer, "f")], "f");
            return true;
        }
        else {
            __classPrivateFieldSet(this, _AsyncEnumerator_current, undefined, "f");
            return false;
        }
    }
}
_AsyncEnumerator_baseArray = new WeakMap(), _AsyncEnumerator_pointer = new WeakMap(), _AsyncEnumerator_current = new WeakMap();
